import React from "react";

import { Navigate, Routes, Route } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";

import useOrganizationFromURL from "./pages/members/hooks/useOrganizationFromURL";
import { useIsTeamsEnabled } from "./pages/teams/hooks/useIsTeamsEnabled";

const Page = React.lazy(() => import("./Page"));
const BasicsPage = React.lazy(() => import("./pages/basics/Page"));
const UsersPage = React.lazy(() => import("./pages/members/Page"));
const MemberPage = React.lazy(() => import("./pages/member/routes"));
const TeamsRoutes = React.lazy(() => import("./pages/teams/routes"));
const SecurityPage = React.lazy(() => import("./pages/security/Page"));

const OrganizationSettingsRoutes = () => {
  const { organizationId } = useDecodedParams();
  const organization = useOrganizationFromURL();
  const isTeamsEnabled = useIsTeamsEnabled();
  const showAccessScreens = !!organization?.hasLink("members");

  return (
    <Page>
      {/* we must let the <Page /> component render since it loads the
          organization profile if the organization is not in the org list
          response. this could happen when the user is staff and trying to
          open a organization they don't have access to.
      */}
      {organization ? (
        <Routes>
          <Route
            path="users/:id"
            element={
              showAccessScreens ? (
                <MemberPage />
              ) : (
                <Navigate to={`/${organizationId}`} />
              )
            }
          />
          <Route
            path="users"
            element={
              showAccessScreens ? (
                <UsersPage />
              ) : (
                <Navigate to={`/${organizationId}`} />
              )
            }
          />
          <Route
            path="security"
            element={<SecurityPage organizationId={organization.id} />}
          />
          {isTeamsEnabled === "loading" ? null : (
            <Route
              path="teams/*"
              element={
                ["enabled", "disabled-promote-links"].includes(
                  isTeamsEnabled
                ) && showAccessScreens ? (
                  <TeamsRoutes />
                ) : (
                  <Navigate to={`/${organizationId}`} />
                )
              }
            />
          )}
          <Route exact path="" element={<BasicsPage />} />
        </Routes>
      ) : null}
    </Page>
  );
};
export default OrganizationSettingsRoutes;
